import { Grid, Stack } from '@mui/material';
import { httpsCallable } from 'firebase/functions';
import { useState } from 'react';
import { Form, Col } from 'react-bootstrap'; // Added import
import { useTranslation } from 'react-i18next';

import { useGetCompanies } from '../../api';
import AdminMainContainer from '../../components/AdminMainContainer';
import AdminReportCard from '../../components/AdminReportCard/AdminReportCard';
import Button from '../../components/Button';
import FgiModal from '../../components/FgiModal';
import Loader from '../../components/Loader';
import Title from '../../components/PageTitle';
import { functions } from '../../firebaseConfig';
import AdminLayout from '../../HOC/AdminLayout';
import {
  getAllianzUserReport,
  getAllianzUserBreakdown,
  getBillingReport,
  Monitoring,
} from '../../utils';

const AdminReports = () => {
  const [t] = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [eLearningReportModalVisible, setELearningReportModalVisibility] =
    useState(false);
  const companies = useGetCompanies();

  const [selectedCompanyId, setSelectedCompanyId] = useState();

  const downloadReport = (getReport) => async () => {
    try {
      setIsLoading(true);
      await getReport();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  const reportCards = [
    {
      title: 'LISTE ALLER #LEAD-NUTZER',
      text: 'Lädt eine Excel-Datei mit allen Nutzern der #lead-Plattform herunter.',
      onButtonClick: downloadReport(getAllianzUserReport),
    },
    {
      title: 'ZUSAMMENFASSUNG ALLER #LEAD-NUTZER',
      text: 'Lädt eine Excel-Datei mit einer Zusammenfassung aller Nutzer der #lead-Plattform nach Bereich herunter.',
      onButtonClick: downloadReport(getAllianzUserBreakdown),
    },
    {
      title: 'Liste aller E-Learning-Registrierungen',
      text: 'Lädt eine Excel-Datei mit allen E-Learning-Registrierungen herunter.',
      onButtonClick: (
        resolve = () => {},
        reject = () => {},
        cancelled = () => {},
      ) => {
        setELearningReportModalVisibility(true);

        // Store callbacks for later use
        AdminReports.cancelledCallback = cancelled;
        AdminReports.resolveCallback = resolve;
        AdminReports.rejectCallback = reject;
      },
    },
    {
      title: 'ALLIANZ BILLING REPORT',
      text: 'Die Auflistung aller Buchungen für die Abrechnung bei der Alllianz.',
      onButtonClick: downloadReport(getBillingReport),
    },
    {
      title: 'Allianz Buchungen',
      text: 'Die Auflistung aller Buchungen samt Name des Teams für die interne Auswertung.',
      onButtonClick: async (resolve = () => {}, reject = () => {}) => {
        try {
          const createReport = httpsCallable(
            functions,
            'questionnaireApp-exportBookings-uiEndpoint',
          );

          await createReport();
          resolve();
        } catch (err) {
          Monitoring.captureException(err);
          reject();
        }
      },
    },
  ];

  return (
    <AdminLayout>
      <Title color="yellow" text={t('Berichte')} width="14%" />
      <AdminMainContainer>
        <Grid
          container
          spacing={4}
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          sx={{
            backgroundColor: 'common.white',
          }}
        >
          {reportCards.map(({ onButtonClick, title, text }, index) => (
            <Grid item xs={4} key={index}>
              <AdminReportCard
                onButtonClick={onButtonClick}
                title={title}
                text={text}
              />
            </Grid>
          ))}
        </Grid>
      </AdminMainContainer>
      <Loader show={isLoading} />
      <FgiModal
        show={eLearningReportModalVisible}
        onHide={() => {
          setELearningReportModalVisibility(false);
          AdminReports.cancelledCallback();
        }}
        title="Bericht erstellen"
        description="Eine Excel-Datei mit allen E-Learning-Registrierungen des ausgewählten Unternehmens wird per E-Mail gesendet."
        showCloseButton
        showBackButton
        className="fgi-modal"
        color="yellow"
      >
        <Stack spacing={2}>
          <Form.Group as={Col}>
            <Form.Label>Unternehmen wählen</Form.Label>
            <Form.Control
              as="select"
              name="companyId"
              onChange={(event) => {
                setSelectedCompanyId(event.target.value);
              }}
            >
              <option>Alle Unternehmen</option>
              {companies?.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Button
            size="medium"
            style={{ minWidth: '190px' }}
            type="submit"
            variant="main"
            onClick={async () => {
              try {
                const createReport = httpsCallable(
                  functions,
                  'reports-elearning-uiEndpoint',
                );

                createReport({ filterby: { companyId: selectedCompanyId } })
                  .then(() => AdminReports.resolveCallback())
                  .catch((err) => {
                    Monitoring.captureException(err);
                    AdminReports.rejectCallback();
                  });
              } catch (err) {
                Monitoring.captureException(err);
                AdminReports.rejectCallback();
              } finally {
                setELearningReportModalVisibility(false);
              }
            }}
          >
            Bericht erstellen
          </Button>
        </Stack>
      </FgiModal>
    </AdminLayout>
  );
};

export default AdminReports;
